import { CheckoutServiceURL } from '../constants/checkout-constants';
import API from './api';
import { logError } from '../../../utils/console-utility';

class ApuOrderDetails {
  static async getApuOrderData(productId): Promise<any> {
    
  const response = await API.get(`${CheckoutServiceURL.APU_ORDER_URL}/fetchAll?view=license&productId=${productId}`)?.catch((err) => {
    logError('Error fetching and parsing data - apu order details ', err)
  })
    return response ? response.data : {};
  }
    
}

export default ApuOrderDetails;